const positiveInteger = (value) => (
  Number.isSafeInteger(Number(value)) && Number(value) > 0 ? Number(value) : null
);

export const getInstallmentPresentation = (transaction) => {
  const current = positiveInteger(transaction?.installmentNumber);
  const total = positiveInteger(transaction?.totalInstallments);
  if (!current || !total || current > total) return null;
  return { current, total, label: `${current}/${total}` };
};

export const getTransactionDisplayName = (transaction, fallback = 'Sem descrição') => {
  const original = String(transaction?.name ?? transaction?.nome ?? transaction?.description ?? '').trim();
  const base = original || fallback;
  const installment = getInstallmentPresentation(transaction);
  if (!installment) return base;
  const escaped = installment.label.replace('/', '\\/');
  const duplicateSuffix = new RegExp(`\\s*(?:[·-]\\s*)?(?:parcela\\s*)?${escaped}\\s*$`, 'i');
  const cleanBase = base.replace(duplicateSuffix, '').trim() || base;
  return `${cleanBase} · ${installment.label}`;
};
